import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { catchError, finalize, Observable, take } from 'rxjs';
import { BANNER_TYPE } from 'src/app/components/banner/banner.constants';
import { IOption } from 'src/app/components/shared/form/components/form-select/form-select.model';
import { environment } from 'src/app/environments/environment';
import { SortCodeResponse } from '../../../models/sort-code.model';
import { CommonUtils } from '../../../utils/common/common.utils';
import { ErrorhandleService } from '../../error-handling/error-handle/errorhandle.service';

@Injectable({
  providedIn: 'root',
})
export class SortCodeService {
  private readonly _http = inject(HttpClient);
  private readonly _commonUtils = inject(CommonUtils);
  private readonly _errorHandler = inject(ErrorhandleService);

  readonly baseUrl = environment.apiUrl.concat(
    '/position-based-operation/clear-security-scan',
  );

  readonly sortCodeOption = signal<IOption[]>([]);

  /**
   *Get sort codes
   * @return {*}  {Observable<SortCodeResponse>}
   * @memberof ClearSecurityScreeningService
   */
  getSortCodes(): Observable<SortCodeResponse> {
    this._commonUtils.updateLoadingModal(true);
    return this._http
      .get<SortCodeResponse>(this.baseUrl.concat('/sort-codes'))
      .pipe(
        take(1),
        catchError((error) =>
          this._errorHandler.handleError<SortCodeResponse>(
            error,
            error.error.code,
            'ClearSecurityScreening Service: Sort codes',
            BANNER_TYPE.SORT_CODES_ERROR,
          ),
        ),
        finalize(() => {
          this._commonUtils.updateLoadingModal(false);
        }),
      );
  }
}
